export enum ErrorMessage {
  TOKEN_INVALID = 'TOKEN_INVALID_MESSAGE',
  TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND_MESSAGE',
  TOKEN_BAD_REQUEST = 'TOKEN_BAD_REQUEST_MESSAGE',
}
